import getEnv from "./getEnv";

function parseDocumentosLista(raw: string | undefined): string[] {
  if (!raw || !String(raw).trim()) {
    return [];
  }
  return String(raw)
    .split(/[,;]/)
    .map((s) => s.trim().replace(/\D/g, ""))
    .filter(Boolean);
}

function documentosDigitosCorrespondem(a: string, b: string): boolean {
  const da = String(a || "").replace(/\D/g, "");
  const db = String(b || "").replace(/\D/g, "");
  if (da == "" || db == "") {
    return false;
  }
  if (da == db) {
    return true;
  }
  if (da.length <= 11 && db.length <= 11) {
    return da.padStart(11, "0") == db.padStart(11, "0");
  }
  return false;
}

export function getQuestionarioSatisfacaoCodigo(): string {
  return String(getEnv("REACT_APP_QUESTIONARIO_SATISFACAO_CODIGO") || "").trim();
}

export function resolveQuestionarioSatisfacaoHabilitado(
  cpfMotorista: string | undefined
): boolean {
  if (!getQuestionarioSatisfacaoCodigo()) {
    return false;
  }

  const cpfsHabilitados = parseDocumentosLista(
    getEnv("REACT_APP_QUESTIONARIO_SATISFACAO_CPFS_HABILITADOS")
  );

  if (cpfsHabilitados.length == 0) {
    return true;
  }

  const cpf = String(cpfMotorista || "").replace(/\D/g, "");
  return cpfsHabilitados.some((c) => documentosDigitosCorrespondem(c, cpf));
}
